import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './index.css'
import { useAuthStore } from './stores/auth'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Initialize auth store
const authStore = useAuthStore()
// Initialize auth asynchronously
authStore.initAuth().then(() => {
  console.log('Auth initialized')
}).catch((error) => {
  console.error('Auth initialization failed:', error)
})

app.mount('#app')
